import React from "react";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import PosterFallback from "../../assests/no-poster.png";
import "./moviecard.scss"
import Lazyload from "../lazy/Lazyload";
import CircleRating from "../circlerating/CircleRating";
import Genere from "../genere/Genere";


const Moviecard = ({ data, fromSearch }) => {

    console.log(data)
    const url = useSelector(state => state.home.imgurl)
      
    const posterUrl = data.poster_path
        ? url.poster + data.poster_path
        : PosterFallback;

        const navigate = useNavigate()
    return (
        <div
            className="movieCard"
            onClick={() =>
                navigate(`${data.id}`) // for details navigate
            }
        >
            <div className="posterBlock">
                <Lazyload
                 className="posterImg" src={posterUrl} />
                {!fromSearch && (
                    <React.Fragment>
                        <CircleRating rating={data.vote_average.toFixed(1)} />
                        <Genere data={data.genre_ids.slice(0, 2)} />
                    </React.Fragment>
                )}
            </div>
            <div className="textBlock">
                <span className="title">{data.title || data.name}</span>
                <span className="date">
                    {dayjs(data.release_date).format("MMM D, YYYY")}
                </span>
            </div>
        </div>
    );
};

export default Moviecard;